import React, {useState} from 'react';
import styles  from "../styles/editProfile.module.css"
import userimg from "../assets/svgs/userimg.svg";






const EditProfile = () => {
  return (
    <div className={styles.editWrapper}>
      <div className={styles.header}>Edit profile</div>
      <img src={userimg} alt="" className={styles.userImg} />
      <p className={styles.actName}>Okpala Oluwayimisola</p>

      <div className={styles.editForm}>
        <form action="">
          <label htmlFor="emailAddress">Email address</label>
          <input type="email" name="" id="" placeholder='Enter your email address' />

          <label htmlFor="phoneNumber">Phone number</label>
          <input type="text" name="" id="" placeholder='Enter your phone number' />

          <label htmlFor="Gender">Gender</label>
          <select name="" id="" className={styles.dropdown}>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          <label htmlFor="DOB">Date of birth</label>
          <input type="date" name="" id="" />

          <div className={styles.btns}>
          <button className={styles.cancel}>Cancel</button>
          <button className={styles.save} >Save profile</button>
          </div>
        </form>
      </div>


    </div>
  )
}

export default EditProfile